/* Matcha Sunday — tasteful scroll reveals (progressive enhancement).
   Sections gently fade/rise as they enter view. Respects reduced-motion.
   Mobile-first: light, passive, one-shot, GPU-friendly. */
(function () {
  try {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    var selector = '.mscmp, .msben, .msrit, .msst, .msrev';
    var els = [].slice.call(document.querySelectorAll(selector));
    if (!els.length) return;

    els.forEach(function (el) { el.classList.add('ms-reveal'); });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('ms-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    els.forEach(function (el) { io.observe(el); });
  } catch (e) { /* never block render */ }
})();
